import {
  FETCH_SIGNUPCOUNTRY_ACTION,
  FETCH_SIGNUPCOUNTRY_SUCCESS_ACTION,
  FETCH_SIGNUPCOUNTRY_FAIL_ACTION,
} from "./action";

const initialState = {
  prcssng: false,
  error: false,
};

export default function (state, action) {
  switch (action.type) {
    case FETCH_SIGNUPCOUNTRY_ACTION:
      return {
        ...state,
        processing: true,
      };

    case FETCH_SIGNUPCOUNTRY_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        error: false,
        errorCode: null,
        errorMessage: null,
        // countryList: action.payload.rows.sort(function (a, b) {
        //   let nameA = a.name.toLowerCase();
        //   let nameB = b.name.toLowerCase();
        //   if (nameA < nameB) return -1;
        //   if (nameA > nameB) return 1;
        //   return 0;
        // }),
        countryprofdetailList: action.payload.rows,
      };

    case FETCH_SIGNUPCOUNTRY_FAIL_ACTION:
      return {
        ...state,
        processing: false,
      };

    default:
      return {
        ...state,
      };
  }
}
